import api from "../http-request";

export const getListNotification = async (params) =>
  api.get(`api/notifications/fe-list`, {params});
export const getDetailNotification = async (id) =>
  api.get(`api/notifications/fe-detail/${id}`);